import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { TabPanelProps } from "../../screens/Tabs.MUI/Tabs.interface";
import NocGrid from "./../Temporary Components/NocGrid";
import DownloadIcon from "@mui/icons-material/Download";
import View from "../../assets/view.svg";
import DeleteIcon from "../../assets/Delete.svg";
import { StartButton, TabButton } from "./Noc.styled";
import { Link, useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import TrackRequests from "./TrackRequests";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import SearchIcon from "../../assets/search-icon.svg";
import pdf from "../../assets/PdfIcon.svg";
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, padding: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const NocTabs = ({ tabIndex = null }: { tabIndex?: number | null }) => {
  const navigate = useNavigate();

  const [trackRequestModal, setTrackRequestModal] = React.useState(false);

  const [value, setValue] = React.useState(tabIndex != null ? tabIndex : 0);
  const [filter, setFilter] = React.useState<string | null>(null);
  const [selectFilter, setSelectFilter] = React.useState({
    payment: "all",
    account: "all",
  });

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const toz = event.target.value;
    setFilter(toz);
  };

  const handleOpenTrackRequestsModal = () => {
    setTrackRequestModal(true);
    // window.open('http://213.42.234.23:8903/home/ourservices/forms')
  };

  const handleCloseTrackRequestsModal = () => {
    setTrackRequestModal(false);
  };

  const Download = () => {
    return <DownloadIcon style={{ color: "blue" }} />;
  };

  const ViewAndDownload = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <img src={View} alt="" />
        <img src={DeleteIcon} alt="" />
      </div>
    );
  };

  const ViewComponent = () => {
    return <img src={View} alt="" />;
  };
  const TabButtons = (props: any) => {
    return (
      <TabButton
        style={{
          color: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "white",
          background: contrast?.contrastColor
            ? contrast?.contrastColor
            : "rgb(16, 30, 142)",
          width: isLargeScreen ? "auto" : "100%",
        }}
        color={props.color}
        onClick={props.onClick ? props.onClick : null}
      >
        {props.text}
      </TabButton>
    );
  };

  const handlePSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectFilter((old) => {
      return {
        ...old,
        payment: e.target.value,
      };
    });
  };

  const handleASelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectFilter((old) => {
      return {
        ...old,
        account: e.target.value,
      };
    });
  };

  const navigateToApplyNOC = () => {
    navigate("/noc-apply");
  };

  const navigateToPaymentPlan = () => {
    navigate("/payment-plan");
  };

  const [isLargeScreen, setIsLargeScreen] = React.useState(false);

  React.useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigateToSocialCase = () => {
    navigate("/social-case-consideration");
  };
  const setColorContrastClass = (valueID: number, textClass: string, contrastColor: string) => {
    return textClass === null ?
      value === valueID ? // null
        (contrastColor === "" || typeof (contrastColor) === 'undefined') ? textClass === 'greenText' ? 'selectedInnerTabGreen' : 'innerTab' || 'whiteText' : contrastColor === 'yellow' ? "yellowText selectedInnerTabYellow" : "limeText selectedInnerTabLime"//active tab
        : (contrastColor === "" || typeof (contrastColor) === 'undefined') ? textClass === 'greenText' ? 'not-selectedGreen' : '' : contrastColor === 'yellow' ? "blueText selectedInnerTabBlue" : "blackText "// non active tab
      : value === valueID ? // !null
        contrastColor === "" || typeof (contrastColor) === 'undefined' ? textClass === 'greenText' ? 'selectedInnerTabGreen' : 'selectedInnerTabBlack' || 'whiteText' : contrastColor === 'yellow' ? "yellowText selectedInnerTabYellow" : "limeText selectedInnerTabLime"//active tab
        : contrastColor === "" || typeof (contrastColor) === 'undefined' ? textClass === 'greenText' ? 'not-selectedGreen' : 'not-selectedBlack' : contrastColor === 'yellow' ? "blueText not-selectedYellow" : "blackText not-selectedLime"// non active tab

  }
  const navigateToRefundTransfer = () => {
    navigate("/refund");
  };
  const navigateToMoveoutDispute = () => {
    navigate("/moveout-dispute");
  };
  React.useEffect(() => {
    setFilter(null);
    setSelectFilter({ payment: "all", account: "all" });
  }, [value]);

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <Box sx={{ width: "100%", height: "90vh" }}>
      <Box
        sx={{
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "#E7E9F8",
          color: contrast?.contrastColor ? contrast?.contrastColor : "",
          paddingLeft:
            General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode !==
            "ARA"
              ? "80px"
              : "",
          paddingRight:
            General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode ===
            "ARA"
              ? "80px"
              : "",
          "@media screen and (max-width: 768px)": {
            paddingLeft: "0", // Adjust padding for smaller screens if needed
            paddingRight: "0", // Adjust padding for smaller screens if needed
          },
        }}
      >
        <Tabs
          className="paymentTabs "
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          //remove border bottom
          TabIndicatorProps={{
            style: {
              display: "none",
            },
          }}
          sx={{
            width: "100%",
          }}
          variant="scrollable"
          allowScrollButtonsMobile
        >
          <Tab
            label={
              <span
                style={{
                  fontSize: `${
                    isLargeScreen ? 1.125 : 0.8 * General.accessibility.fontSize
                  }rem`,
                  fontWeight: 700,
                }}
                 //className={General?.textClass? value !== 0? "whiteText":"blackText":""}
              >
                {General?.codeLabels["cm_view_validnoc"]?.label? General?.codeLabels["cm_view_validnoc"]?.label: "VIEW VALID NOCs"}
              </span>
            }
            {...a11yProps(0)}
            className={setColorContrastClass(0,General.textClass, General.contrast.contrastColor)}
            sx={{
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
              "&.Mui-selected": {
                outline: "none",
              },
            }}
          />
          <Tab
            label={
              <span
                style={{
                  fontSize: `${
                    isLargeScreen ? 1.125 : 0.8 * General.accessibility.fontSize
                  }rem`,
                  fontWeight: 700,
                }}
                 //className={General?.textClass? value !== 1? "whiteText":"blackText":""}
              >
                {General?.codeLabels["cm_dash_recent"]?.label
                  ? General?.codeLabels["cm_dash_recent"]?.label
                  : "Recent Requests"}
              </span>
            }
            {...a11yProps(1)}
            className={setColorContrastClass(1,General.textClass, General.contrast.contrastColor)}
            sx={{
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
              marginLeft: "2px",
              zIndex: "0",
              "&.Mui-selected": {
                outline: "none",
              },
            }}
          />
         
          <Tab
            label={
              <span
                style={{
                  fontSize: `${
                    isLargeScreen ? 1.125 : 0.8 * General.accessibility.fontSize
                  }rem`,
                  fontWeight: 700,
                }}
                 //className={General?.textClass? value !== 3? "whiteText":"blackText":""}
              >
                {General?.codeLabels["cm_socialcase"]?.label
                  ? General?.codeLabels["cm_socialcase"]?.label
                  : "SOCIAL CASES"}
              </span>
            }
            {...a11yProps(3)}
            className={setColorContrastClass(2,General.textClass, General.contrast.contrastColor)}
            sx={{
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
              marginLeft: "2px",
              zIndex: "0",
              "&.Mui-selected": {
                outline: "none",
              },
            }}
          />
          <Tab
            label={
              <span
                style={{
                  fontSize: `${
                    isLargeScreen ? 1.125 : 0.8 * General.accessibility.fontSize
                  }rem`,
                  fontWeight: 700,
                }}
                 //className={General?.textClass? value !== 4? "whiteText":"blackText":""}
              >
                {General?.codeLabels["cm_refundhistory"]?.label
                  ? General?.codeLabels["cm_refundhistory"]?.label
                  : "Refund History"}
              </span>
            }
            {...a11yProps(3)}
            className={setColorContrastClass(3,General.textClass, General.contrast.contrastColor)}
            sx={{
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
              marginLeft: "2px",
              zIndex: "0",
              "&.Mui-selected": {
                outline: "none",
              },
            }}
          />
          {/* <Tab
            label={
              <span
                style={{
                  fontSize: `${
                    isLargeScreen ? 1.125 : 0.8 * General.accessibility.fontSize
                  }rem`,
                  fontWeight: 700,
                }}
                 //className={General?.textClass? value !== 4? "whiteText":"blackText":""}
              >
                {"Moveout Dispute"}
              </span>
            }
            {...a11yProps(4)}
            className={setColorContrastClass(4,General.textClass, General.contrast.contrastColor)}
            sx={{
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "#fff",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101E8E",
              marginLeft: "2px",
              zIndex: "0",
              "&.Mui-selected": {
                outline: "none",
              },
            }}
          /> */}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <NocGrid
          className='NocReqText'
          index={0}
          children={<img src={pdf} alt="" />}
          children2={
            <div
            className="w-100 d-flex"
            style={{
              display: "flex",
              height: "3rem",
              justifyContent: isLargeScreen ? "end" : "center",
              padding:General?.isLargeScreen?"":"1rem",
              marginBottom: General?.isLargeScreen?"":"1rem"
            }}
          >
            <button
              // onClick={navigateToApplyNOC}
              style={{
                
                  backgroundColor: General.contrast.contrastBackground
                    ? General.contrast.contrastColor
                    : General?.ColorAss,
                fontFamily: "Segoe UI",
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: `${General.accessibility.fontSize}rem`,
                lineHeight: " 20px",
                padding: "10px",
                position: "relative",
                height: isLargeScreen ? "50px" : "55px",
                width: isLargeScreen ? "168px" : "100%",
                border: "none",
              
              }}
              //className="NocReqButton"
            >
              <Link
                style={{
                  color: General.contrast.contrastColor
                    ? General.contrast.contrastBackground
                    : '#fff',
                    textTransform:'uppercase'
                }}
                to="/noc-apply"
                state={{ login: false }}
              >
                {" "}
                {General?.codeLabels["cm_applynoc"]?.label !== undefined
                  ? General?.codeLabels["cm_applynoc"]?.label
                  : "APPLY FOR NOC"}
              </Link>
            </button>
            </div>
          }
          children3={
            <>
              <select
                className="NocReqSelect"
                onChange={handleASelectChange}
                defaultValue={"all"}
                style={{
                  marginLeft: isLargeScreen ? "" : "10px",
                  width: "10.5rem",
                  height: "2.5rem",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101E8E",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                }}
              >
                <option value={"all"}>
                  {General?.codeLabels["cm_all_acc"]?.label
                    ? General?.codeLabels["cm_all_acc"]?.label
                    : "All Accounts"}
                </option>
              </select>
            </>
          }
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <NocGrid
          index={1}
          filter={filter}
          children={<img src={pdf} alt="" />}
          children2={
            <div
              className="w-100 d-flex"
              style={{
                display: "flex",
                height: "3rem",
                justifyContent: isLargeScreen ? "end" : "center",
                padding:General?.isLargeScreen?"":"1rem",
                marginBottom: General?.isLargeScreen?"":"1rem"
              }}
            >
              <button
                onClick={handleOpenTrackRequestsModal}
                style={{
                  display:"none",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  lineHeight: " 20px",
                  position: "relative",
                  border: "none",
                  whiteSpace: "nowrap",
                  height: isLargeScreen ? "50px" : "55px",
                  width: isLargeScreen ? "168px" : "100%",
                  color: General.contrast.contrastColor
                  ? General.contrast.contrastBackground
                  : '#fff',
                  background: General.contrast.contrastBackground
                  ? General.contrast.contrastColor
                  : General?.ColorAss,
                    zIndex:'0'
                }}
                //className="NocReqButton"
              >
                {General?.codeLabels["cm_trackrequest"]?.label
                  ? General?.codeLabels["cm_trackrequest"]?.label
                  : "TRACK A REQUEST"}
              </button>
            </div>
          }
          children3={
            <Box
              sx={{
                display: "flex",
                "@media screen and (max-width: 560px)": {
                  flexDirection: "column",
                  gap: "20px",
                },
              }}
            >
              <select
                onChange={handlePSelectChange}
                defaultValue={"all"}
                style={{
                
                  width: "10.5rem",
                  height: "2.5rem",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  marginRight: "10px",
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101E8E",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                  marginLeft: isLargeScreen ? "14px" : "",

                }}
              >
                <option value={"all"}>
                  {General?.codeLabels["cm_all_status"]?.label
                    ? General?.codeLabels["cm_all_status"]?.label
                    : "All Status"}
                </option>
                <option value={"Started"}>
                  {General?.codeLabels["cm_started"]?.label !== undefined
                    ? General?.codeLabels["cm_started"]?.label
                    : "Started"}
                </option>
                <option value={"In Progress"}>
                  {General?.codeLabels["cm_noc_status2"]?.label !== undefined
                    ? General?.codeLabels["cm_noc_status2"]?.label
                    : "In Progress"}
                </option>
                <option value={"Completed"}>
                  {General?.codeLabels["cm_noc_status1"]?.label !== undefined
                    ? General?.codeLabels["cm_noc_status1"]?.label
                    : "Completed"}
                </option>
              </select>

              <select
                onChange={handleASelectChange}
                defaultValue={"all"}
                style={{
                 
                  marginLeft: isLargeScreen ? "1rem" : "",
                  width: "10.5rem",
                  height: "2.5rem",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101E8E",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                  // marginTop:"10px",
                  // marginLeft:"0"
                }}
              >
                <option value={"all"}>
                  {General?.codeLabels["cm_all_acc"]?.label
                    ? General?.codeLabels["cm_all_acc"]?.label
                    : "All Accounts"}
                </option>
              </select>
            </Box>
          }
          children4={
            <div
              className="w-100 d-flex"
              style={{
                display: "flex",
                height: "3rem",
                justifyContent: isLargeScreen ? "end" : "center",
                padding:General?.isLargeScreen?"":"0rem 1rem"
              }}
            >
              <input
                className="searchButton3"
                type={"text"}
                onChange={handleSearchChange}
                placeholder={
                  General?.codeLabels["cm_search"]?.label
                    ? General?.codeLabels["cm_search"]?.label
                    : "Search"
                }
                style={{
                  width: isLargeScreen ? "276px" : "100%",

                  paddingLeft: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '40px' : '10px',
                  paddingRight: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '10px' : '40px', // Adjust the padding to make space for the icon
                  height: "50px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101E8E",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                  marginInlineEnd: isLargeScreen ? "20px" : "0px",
                  backgroundImage: `url(${SearchIcon})`, // Set the background image
                  backgroundPosition: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? 'left 10px center' : 'right 10px center', // Adjust the position of the icon
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "20px 20px", // Adjust the size of the icon
                }}
              />
            </div>
          }
        />
      </TabPanel>
    
      <TabPanel value={value} index={2}>
        <NocGrid
          filter={filter}
          index={3}
          width="96%"
          children={<ViewComponent />}
          children2={
            <div
              className="w-100 d-flex"
              style={{
                display: "flex",
                height: "3rem",
                justifyContent: isLargeScreen ? "end" : "center",
                padding:General?.isLargeScreen?"":"1rem",
                marginBottom: General?.isLargeScreen?"":"1rem"
              }}
            >
              <button
                onClick={navigateToSocialCase}
                style={{
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  lineHeight: " 20px",
                  position: "relative",
                  border: "none",

                  whiteSpace: "nowrap",
                  height: isLargeScreen ? "50px" : "55px",
                  width: isLargeScreen ? "auto" : "100%",
                  color: General.contrast.contrastColor
                  ? General.contrast.contrastBackground
                  : '#fff',
                  background: General.contrast.contrastBackground
                  ? General.contrast.contrastColor
                  : General?.ColorAss,
                }}
                //className="NocReqButton"
              >
                {General?.codeLabels["cm_start_app"]?.label
                  ? General?.codeLabels["cm_start_app"]?.label
                  : "START NEW APPLICATION"}
              </button>
            </div>
          }
          children4={
            <div
              className="w-100 d-flex"
              style={{
                display: "flex",
                height: "3rem",
                justifyContent: isLargeScreen ? "end" : "center",
                padding:General?.isLargeScreen?"":"0rem 1rem"
              }}
            >
              <input
                className="searchButton3"
                type={"text"}
                onChange={handleSearchChange}
                placeholder={
                  General?.codeLabels["cm_search"]?.label
                    ? General?.codeLabels["cm_search"]?.label
                    : "Search"
                }
                style={{
                  width: isLargeScreen ? "276px" : "100%",

                  paddingLeft: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '40px' : '10px',
                  paddingRight: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? '10px' : '40px', // Adjust the padding to make space for the icon
                  height: "50px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101E8E",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                  marginInlineEnd: isLargeScreen ? "20px" : "0px",
                  backgroundImage: `url(${SearchIcon})`, // Set the background image
                  backgroundPosition: General?.codeLabels["cm_search"]?.languageCode === 'ARA' ? 'left 10px center' : 'right 10px center', // Adjust the position of the icon
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "20px 20px", // Adjust the size of the icon
                }}
              />
            </div>
          }
        />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <NocGrid
          filter={filter}
          index={4}
          width="96%"
          children2={
            <div
            className="w-100 d-flex"
            style={{
              display: "flex",
              height: "3rem",
              justifyContent: isLargeScreen ? "end" : "center",
              padding:General?.isLargeScreen?"":"1rem",
              marginBottom: General?.isLargeScreen?"":"1rem"
            }}
          >
                <button
                onClick={navigateToRefundTransfer}
                style={{
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  lineHeight: " 20px",
                  position: "relative",
                  border: "none",
                  textTransform: "uppercase",
                  whiteSpace: "nowrap",
                  height: isLargeScreen ? "50px" : "55px",
                  width: isLargeScreen ? "auto" : "100%",
                  color: General.contrast.contrastColor
                  ? General.contrast.contrastBackground
                  : '#fff',
                  background: General.contrast.contrastBackground
                  ? General.contrast.contrastColor
                  : General?.ColorAss,
                }}
                //className="NocReqButton"
              >
                {General?.codeLabels["cm_rquest_refund"]?.label !== undefined ? General?.codeLabels["cm_rquest_refund"]?.label : "REQUEST FOR A REFUND"}
              </button>
          </div>}
          children4={
            <div
              className="w-100 d-flex"
              style={{
                display: "flex",
                height: "3rem",
                justifyContent: isLargeScreen ? "end" : "center",
                padding:General?.isLargeScreen?"":"0rem 1rem"
              }}
            >
              
              <input
                className="searchButton3"
                type={"text"}
                onChange={handleSearchChange}
                placeholder={
                  General?.codeLabels["cm_search"]?.label
                    ? General?.codeLabels["cm_search"]?.label
                    : "Search"
                }
                style={{
                  width: isLargeScreen ? "276px" : "100%",

                  paddingLeft: "10px",
                  paddingRight: "40px", // Adjust the padding to make space for the icon
                  height: "50px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101E8E",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                  marginInlineEnd: isLargeScreen ? "20px" : "0px",
                  backgroundImage: `url(${SearchIcon})`, // Set the background image
                  backgroundPosition: "right 10px center", // Adjust the position of the icon
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "20px 20px", // Adjust the size of the icon
                }}
              />
         
            </div>
            
          }
        />
      </TabPanel>
      {/* <TabPanel value={value} index={4}>
        <NocGrid
          filter={filter}
          index={5}
          width="96%"
          children2={
            <div
            className="w-100 d-flex"
            style={{
              display: "flex",
              height: "3rem",
              justifyContent: isLargeScreen ? "end" : "center",
              padding:General?.isLargeScreen?"":"1rem",
              marginBottom: General?.isLargeScreen?"":"1rem"
            }}
          >
                <button
                onClick={navigateToMoveoutDispute}
                style={{
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  lineHeight: " 20px",
                  position: "relative",
                  border: "none",
                  textTransform: "uppercase",
                  whiteSpace: "nowrap",
                  height: isLargeScreen ? "50px" : "55px",
                  width: isLargeScreen ? "auto" : "100%",
                  color: General.contrast.contrastColor
                  ? General.contrast.contrastBackground
                  : '#fff',
                  background: General.contrast.contrastBackground
                  ? General.contrast.contrastColor
                  : General?.ColorAss,
                }}
                //className="NocReqButton"
              >
                {"APPLY FOR MOVEOUT DISPUTE"}
              </button>
          </div>}
          children4={
            <div
              className="w-100 d-flex"
              style={{
                display: "flex",
                height: "3rem",
                justifyContent: isLargeScreen ? "end" : "center",
                padding:General?.isLargeScreen?"":"0rem 1rem"
              }}
            >
              
              <input
                className="searchButton3"
                type={"text"}
                onChange={handleSearchChange}
                placeholder={
                  General?.codeLabels["cm_search"]?.label
                    ? General?.codeLabels["cm_search"]?.label
                    : "Search"
                }
                style={{
                  width: isLargeScreen ? "276px" : "100%",

                  paddingLeft: "10px",
                  paddingRight: "40px", // Adjust the padding to make space for the icon
                  height: "50px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#101E8E",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#E5EFF2",
                  marginInlineEnd: isLargeScreen ? "20px" : "0px",
                  backgroundImage: `url(${SearchIcon})`, // Set the background image
                  backgroundPosition: "right 10px center", // Adjust the position of the icon
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "20px 20px", // Adjust the size of the icon
                }}
              />
         
            </div>
            
          }
        />
      </TabPanel> */}
      <Modal open={trackRequestModal} onClose={handleCloseTrackRequestsModal}>
        <TrackRequests onClose={handleCloseTrackRequestsModal} />
      </Modal>
    </Box>
  );
};
export default observer(NocTabs);
